import axios from "axios";

const BASE = "/api/financial-aid";

export function lookup({ email } = {}) {
  return axios.post(`${BASE}/lookup`, { email });
}

export function checkRecord({ email } = {}) {
  return axios.post(`${BASE}/check-record`, { email });
}

export function create(data) {
  return axios.post(BASE, data);
}

export function update(id, { field, value }) {
  return axios.patch(`${BASE}/${id}`, { field, value });
}

export function deleteByEmail({ email } = {}) {
  return axios.post(`${BASE}/delete-by-email`, { email });
}
